import 'core-js' // ! ES6 IE 適配
import Vue from 'vue'
import App from './App'
import routes from './router'
import Router from 'vue-router'
import store from './store'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import animated from 'animate.css'
import i18n from './lang'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.use(Router)
Vue.use(ViewUI)
Vue.use(animated)
Vue.use(VueAwesomeSwiper)

export const defaultRoute = routes.defaultRoutes

const router = new Router({
  base: '',
  routes: defaultRoute
})

// 避免報Uncaught (in promise) NavigationDuplicated
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export const allRoutes = (function () {
  const rawRoutes = []
  rawRoutes.push(defaultRoute[0].path)
  defaultRoute[0].children.forEach(route => {
    rawRoutes.push(route.path)
  })
  return rawRoutes
})()

router.beforeEach((to, from, next) => {
  if (allRoutes.includes(to.path)) {
    next()
  } else {
    next('/index')
  }
})

/* eslint-disable no-new */
new Vue({
  created () {
    AOS.init({ disable: 'phone' })
  },
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  // template: '<App/>'
  render: h => h(App)
})
